import type { BoxProps } from '../box'

import Box from '../box'
import { useStyleConfig, useUp, vui } from '../core'
import zIndices from '../theme/foundations/zIndices'
import { cs, mergeRefs } from '../utils'
import { useHeaderContext } from './context'

/** Displays part of the Header content when on a mobile screen. */
export const HeaderMobileContent = vui<'div', BoxProps>((props, ref) => {
  const { className, ...rest } = props
  const { isMobileOpen, mobileContentRef } = useHeaderContext() ?? {}
  const styles = useStyleConfig('Header', useHeaderContext())
  const isLargerThanTablet = useUp('lg')

  return isMobileOpen ? (
    <Box
      bg="white"
      className={cs('vui-headerMobileContent', className)}
      column
      overflowX="hidden"
      overflowY="auto"
      position="absolute"
      ref={mergeRefs(ref, mobileContentRef)}
      right={isLargerThanTablet ? '-40px' : '-16px'}
      boxShadow="sm"
      top="calc(100% + 1px)"
      w={isLargerThanTablet ? 320 : 280}
      zIndex={zIndices.header}
      {...styles.mobileContent}
      {...rest}
    />
  ) : null
})

HeaderMobileContent.displayName = 'HeaderMobileContent'
export default HeaderMobileContent
